export const useInitUtil = {
  init: data => {
    if (Object.prototype.toString.call(data) !== '[object Object]') {
      return
    }

    for (const key in data) {
      const type = Object.prototype.toString.call(data[key])
      switch (type) {
        case '[object String]':
          data[key] = ''
          break
        case '[object Number]':
          data[key] = 0
          break
        case '[object Boolean]':
          data[key] = false
          break
        case '[object Date]':
          data[key] = null
          break
        case '[object Array]':
          data[key] = []
          break
        case '[object Object]':
          useInitUtil.init(data[key])
          break
      }
    }
  }
}
